import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function CTA() {
  return <section className="py-24 bg-blue-600 relative overflow-hidden" data-id="element-97">
      {/* Abstract Shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-98" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-600 rounded-full blur-3xl opacity-50 -translate-x-1/2 translate-y-1/2" data-id="element-99" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-100">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight" data-id="element-101">
          Gata să obții finanțarea potrivită?
        </h2>
        <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-102">
          Nu lăsa birocrația să îți încetinească afacerea. Verifică
          eligibilitatea acum și primește oferte personalizate.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-103">
          <Button size="lg" className="bg-white text-blue-600 hover:bg-blue-50 border-0 text-lg h-14 px-8" data-id="element-104">
            Califică-te în 30 de secunde
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-105" />
          </Button>
        </div>

        <p className="mt-6 text-sm text-blue-200 opacity-80" data-id="element-106">
          Nu este necesar cardul de credit • Fără obligații
        </p>
      </div>
    </section>;
}